import {
  EngagementStakeholder,
  EngagementThirdPartyRep,
  EngagementBusinessTheme,
  EngagementResponsePerson,
} from '@cradua/domain';

export class EngagementDto {
  public id: string;
  public EngagementId: string;
  public EngagementTitle: string;
  public EngagementProposedDate: Date;
  public EngagementDate: Date;
  public EngagementObjective: string;
  public EngagementDescription: string;
  public EngagementValueAtStake: string;
  public EngagementTypeId: string;
  public EngagementCategoryId: string;
  public EngagementDriverId: string;
  public EngagementLineOfBusinessId: string;
  public EngagementGroupId: string;
  public EngagementCompanyId: string;
  public EngagementParentId: string;
  public ResolutionReached: string;
  public Status: string;

  public engagementStakeholders: Array<EngagementStakeholder>;
  public engagementThirdPartyReps: Array<EngagementThirdPartyRep>;
  public engagementBusinessThemes: Array<EngagementBusinessTheme>;
  public engagementResponsePersons: Array<EngagementResponsePerson>;
}
